// Generated by BUCKLESCRIPT VERSION 4.0.7, PLEASE EDIT WITH CARE

import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Display from "./display";
import * as Calculator from "../utils/calculator";
import * as ButtonPanel from "./buttonPanel";
import * as Caml_string from "bs-platform/lib/es6/caml_string.js";
import * as ReasonReact from "reason-react/src/ReasonReact.js";

import("./app.css");

var initState_003 = /* flag : record */[/* contents */"DEL"];

var initState = /* record */[
  /* fst */"0",
  /* snd */undefined,
  /* op */undefined,
  initState_003
];

var component = ReasonReact.reducerComponent("App");

function buttonActionCreator(name, send) {
  switch (name) {
    case "%" : 
        return Curry._1(send, /* Op */Block.__(1, [/* Percent */3]));
    case "*" : 
        return Curry._1(send, /* Sums */Block.__(0, [/* Multiply */2]));
    case "+" : 
        return Curry._1(send, /* Sums */Block.__(0, [/* Sum */0]));
    case "+/-" : 
        return Curry._1(send, /* Op */Block.__(1, [/* Sign */2]));
    case "-" : 
        return Curry._1(send, /* Sums */Block.__(0, [/* Substract */1]));
    case "." : 
        return Curry._1(send, /* Op */Block.__(1, [/* Point */4]));
    case "/" : 
        return Curry._1(send, /* Sums */Block.__(0, [/* Divide */3]));
    case "0" : 
    case "1" : 
    case "2" : 
    case "3" : 
    case "4" : 
    case "5" : 
    case "6" : 
    case "7" : 
    case "8" : 
    case "9" : 
        return Curry._1(send, /* Number */Block.__(2, [name]));
    case "=" : 
        return Curry._1(send, /* Op */Block.__(1, [/* Equals */5]));
    case "CLS" : 
        return Curry._1(send, /* Op */Block.__(1, [/* Clear */1]));
    case "DEL" : 
        return Curry._1(send, /* Op */Block.__(1, [/* Delelte */0]));
    default:
      return /* () */0;
  }
}

function mapResult(param) {
  var snd = param[/* snd */1];
  var fst = param[/* fst */0];
  if (param[/* op */2] !== undefined && snd !== undefined) {
    return snd;
  } else {
    return fst;
  }
}

function computeState(action, state) {
  var op = state[/* op */2];
  var snd = state[/* snd */1];
  var fst = state[/* fst */0];
  switch (action.tag | 0) {
    case 0 : 
        var newOp = action[0];
        var exit = 0;
        switch (newOp) {
          case 0 : 
              if (snd !== undefined) {
                exit = 1;
              } else {
                return /* record */[
                        /* fst */state[/* fst */0],
                        /* snd */state[/* snd */1],
                        /* op *//* Sum */0,
                        /* flag */state[/* flag */3]
                      ];
              }
              break;
          case 1 : 
              if (snd !== undefined) {
                exit = 1;
              } else {
                return /* record */[
                        /* fst */state[/* fst */0],
                        /* snd */state[/* snd */1],
                        /* op *//* Substract */1,
                        /* flag */state[/* flag */3]
                      ];
              }
              break;
          case 2 : 
              if (snd !== undefined) {
                exit = 1;
              } else {
                return /* record */[
                        /* fst */state[/* fst */0],
                        /* snd */state[/* snd */1],
                        /* op *//* Multiply */2,
                        /* flag */state[/* flag */3]
                      ];
              }
              break;
          case 3 : 
              if (snd !== undefined) {
                exit = 1;
              } else {
                return /* record */[
                        /* fst */state[/* fst */0],
                        /* snd */state[/* snd */1],
                        /* op *//* Divide */3,
                        /* flag */state[/* flag */3]
                      ];
              }
              break;
          
        }
        if (exit === 1) {
          if (op !== undefined) {
            return /* record */[
                    /* fst */Calculator.evalValue(fst, op, snd),
                    /* snd */undefined,
                    /* op */newOp,
                    initState_003
                  ];
          } else {
            return state;
          }
        }
        break;
    case 1 : 
        switch (action[0]) {
          case 0 : 
              if (op !== undefined) {
                if (snd !== undefined) {
                  var y = snd;
                  if (y !== "0") {
                    var match = y.length > 1;
                    return /* record */[
                            /* fst */state[/* fst */0],
                            /* snd */match ? $$String.sub(y, 0, y.length - 1 | 0) : undefined,
                            /* op */state[/* op */2],
                            /* flag */state[/* flag */3]
                          ];
                  } else {
                    return state;
                  }
                } else {
                  return state;
                }
              } else if (snd !== undefined || fst === "0") {
                return state;
              } else {
                var match$1 = fst.length > 1;
                return /* record */[
                        /* fst */match$1 ? $$String.sub(fst, 0, fst.length - 1 | 0) : "0",
                        /* snd */state[/* snd */1],
                        /* op */state[/* op */2],
                        /* flag */state[/* flag */3]
                      ];
              }
          case 1 : 
              return initState;
          case 2 : 
              if (op !== undefined) {
                if (snd !== undefined) {
                  var x = snd;
                  if (x !== "0") {
                    var match$2 = Caml_string.get(x, 0) === /* "-" */45;
                    return /* record */[
                            /* fst */state[/* fst */0],
                            /* snd */match$2 ? $$String.sub(x, 1, x.length - 1 | 0) : "-" + x,
                            /* op */state[/* op */2],
                            /* flag */state[/* flag */3]
                          ];
                  } else {
                    return state;
                  }
                } else {
                  return state;
                }
              } else if (fst !== "0") {
                var match$3 = Caml_string.get(fst, 0) === /* "-" */45;
                return /* record */[
                        /* fst */match$3 ? $$String.sub(fst, 1, fst.length - 1 | 0) : "-" + fst,
                        /* snd */state[/* snd */1],
                        /* op */state[/* op */2],
                        /* flag */state[/* flag */3]
                      ];
              } else {
                return state;
              }
          case 3 : 
              if (op !== undefined) {
                if (snd !== undefined) {
                  var y$1 = snd;
                  if (y$1 !== "0") {
                    return /* record */[
                            /* fst */state[/* fst */0],
                            /* snd */Calculator.percent(y$1),
                            /* op */state[/* op */2],
                            /* flag */state[/* flag */3]
                          ];
                  } else {
                    return state;
                  }
                } else {
                  return state;
                }
              } else if (fst !== "0") {
                return /* record */[
                        /* fst */Calculator.percent(fst),
                        /* snd */state[/* snd */1],
                        /* op */state[/* op */2],
                        /* flag */state[/* flag */3]
                      ];
              } else {
                return state;
              }
          case 4 : 
              if (op !== undefined) {
                if (snd !== undefined) {
                  var y$2 = snd;
                  var match$4 = $$String.contains(y$2, /* "." */46);
                  return /* record */[
                          /* fst */state[/* fst */0],
                          /* snd */match$4 ? snd : y$2 + ".",
                          /* op */state[/* op */2],
                          /* flag */state[/* flag */3]
                        ];
                } else {
                  return state;
                }
              } else {
                var match$5 = $$String.contains(fst, /* "." */46);
                return /* record */[
                        /* fst */match$5 ? fst : fst + ".",
                        /* snd */state[/* snd */1],
                        /* op */state[/* op */2],
                        /* flag */state[/* flag */3]
                      ];
              }
          case 5 : 
              if (op !== undefined && snd !== undefined) {
                return /* record */[
                        /* fst */Calculator.evalValue(fst, op, snd),
                        /* snd */undefined,
                        /* op */undefined,
                        initState_003
                      ];
              } else {
                return state;
              }
          
        }
    case 2 : 
        var x$1 = action[0];
        var exit$1 = 0;
        var exit$2 = 0;
        if (x$1 === "0" && (fst === "0" || snd !== undefined && snd === "0")) {
          return state;
        } else {
          exit$2 = 2;
        }
        if (exit$2 === 2) {
          if (fst === "0") {
            return /* record */[
                    /* fst */x$1,
                    /* snd */state[/* snd */1],
                    /* op */state[/* op */2],
                    /* flag */state[/* flag */3]
                  ];
          } else if (snd !== undefined && snd === "0") {
            return /* record */[
                    /* fst */state[/* fst */0],
                    /* snd */x$1,
                    /* op */state[/* op */2],
                    /* flag */state[/* flag */3]
                  ];
          } else {
            exit$1 = 1;
          }
        }
        if (exit$1 === 1) {
          if (op !== undefined) {
            if (snd !== undefined) {
              return /* record */[
                      /* fst */state[/* fst */0],
                      /* snd */snd + x$1,
                      /* op */state[/* op */2],
                      /* flag */state[/* flag */3]
                    ];
            } else {
              return /* record */[
                      /* fst */state[/* fst */0],
                      /* snd */x$1,
                      /* op */state[/* op */2],
                      /* flag */state[/* flag */3]
                    ];
            }
          } else {
            return /* record */[
                    /* fst */fst + x$1,
                    /* snd */state[/* snd */1],
                    /* op */state[/* op */2],
                    /* flag */state[/* flag */3]
                  ];
          }
        }
        break;
    
  }
}

function make(_children) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */(function (self) {
              var keyUpHandle = function (evt) {
                var name = evt.key;
                switch (name) {
                  case "Backspace" : 
                      return buttonActionCreator("CLS", self[/* send */3]);
                  case "Delete" : 
                      return buttonActionCreator("DEL", self[/* send */3]);
                  case "Enter" : 
                      return buttonActionCreator("=", self[/* send */3]);
                  case "x" : 
                      return buttonActionCreator("*", self[/* send */3]);
                  default:
                    return buttonActionCreator(name, self[/* send */3]);
                }
              };
              window.addEventListener("keyup", keyUpHandle);
              return Curry._1(self[/* onUnmount */4], (function (param) {
                            window.removeEventListener("keyup", keyUpHandle);
                            return /* () */0;
                          }));
            }),
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              var send = param[/* send */3];
              var state = param[/* state */1];
              var handleClick = function (name) {
                return buttonActionCreator(name, send);
              };
              return React.createElement("div", {
                          className: "component-app"
                        }, ReasonReact.element(undefined, undefined, Display.make(mapResult(state), /* array */[])), ReasonReact.element(undefined, undefined, ButtonPanel.make(handleClick, state[/* flag */3][0], /* array */[])));
            }),
          /* initialState */(function (param) {
              return initState;
            }),
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */(function (action, state) {
              var tmp;
              switch (action.tag | 0) {
                case 1 : 
                    tmp = action[0] >= 5 ? "CLS" : "DEL";
                    break;
                case 0 : 
                case 2 : 
                    tmp = "DEL";
                    break;
                
              }
              state[/* flag */3][0] = tmp;
              return /* Update */Block.__(0, [computeState(action, state)]);
            }),
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

export {
  initState ,
  component ,
  buttonActionCreator ,
  mapResult ,
  computeState ,
  make ,
  
}
/*  Not a pure module */
